export const SHIFT_AUCTION_LABEL = "Quick Bid";

export const SHIFT_AUCTION_BID_PAY_PARAMETER_NAME = "inputBidPay";
